import {
  handleCatchErrors,
  responseDataFormat,
  responseDataFormatRedux,
} from "../../../middlewares/resolveRequests";
import * as actionTypes from "../../actions/actionTypes";

import {
  addActivity,
  addActivityProcedureForm,
  addMilestone,
  addProject,
  deleteAct,
  deleteActivityProc,
  deleteMil,
  deleteProj,
  editActivityProcStatus,
  getActivity,
  getActivityAttachments,
  getActivityForm,
  getActivityMembers,
  getActivityProcedureForm,
  getActivityStatus,
  getEditActivityForm,
  getEditMilestoneForm,
  getEditProcedure,
  getEditProjectForm,
  getMilestones,
  getProject,
  getProjectAttachments,
  getProjectCounts,
  getProjectForm,
  getProjectFormSearch,
  getProjectMembers,
  getProjects,
  getProjectStatus,
  searchProjects,
  setActivitiesStatus,
  setProjMemberStatus,
  setProjStatus,
  setStatus,
  updateMilestone,
  updateProject,
} from "../../../services/projects/project";

export const getAllProjects = async (
  communityId,
  pageNo = 1,
  pageCount = 10,
  token
) => {
  let response;
  try {
    response = await getProjects(communityId, pageNo, pageCount, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const getProjectCount = async (communityId, token) => {
  let response;
  try {
    response = await getProjectCounts(communityId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const getCommunityProjectForm = async (communityId, token) => {
  let response;
  try {
    response = await getProjectForm(communityId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const getProjectSearch = async (communityId, token) => {
  let response;
  try {
    response = await getProjectFormSearch(communityId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const getProjectActivityForm = async (projectId, token) => {
  let response;
  try {
    response = await getActivityForm(projectId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const getAllProjectStatus = async (token) => {
  let response;
  try {
    response = await getProjectStatus(token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const getAllProjectMembers = async (projectId, token) => {
  let response;
  try {
    response = await getProjectMembers(projectId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const setProjectMemberStatus = async (id, statusId, token) => {
  let response;
  try {
    response = await setProjMemberStatus(id, statusId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
  }
};

export const setProjectStatus = async (
  projectId,
  cahngeAll,
  statusId,
  resolver,
  request,
  store,
  token
) => {
  if (statusId) {
    let response;
    try {
      response = await setProjStatus(projectId, statusId, cahngeAll, token);
      if (cahngeAll) {
        store(null);
        resolver(request, store, projectId, token);
      }
    } catch (e) {
      response = handleCatchErrors(e);
    }
  }
};

export const addProjectForm = async (data, token) => {
  let response;
  try {
    response = await addProject(data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const addNewMilestone = async (data, token) => {
  let response;
  try {
    response = await addMilestone(data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export async function getProjectMilestones(
  projectId,
  pageNumber,
  pageSize,
  token
) {
  let response;
  try {
    response = await getMilestones(projectId, pageNumber, pageSize, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
}

export const deleteMilestone = async (milestoneId, token) => {
  let response;
  try {
    response = await deleteMil(milestoneId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  }
};

export const getEditDataMilestoneForm = async (
  milestoneId,
  projectId,
  token
) => {
  let response;
  try {
    response = await getEditMilestoneForm(milestoneId, projectId, token);
    // setVisible(true);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const editMilestoneForm = async (data, token) => {
  let response;
  try {
    response = await updateMilestone(data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export async function getProjectDetails(projectId, token) {
  let response;
  try {
    response = await getProject(projectId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
}

export function clearProjectDetails() {
  let status = 200;
  let response = {
    data: status >= 200 && status <= 206 ? true : false,
  };
  return responseDataFormat(response);
}

export async function getActivityDetails(activityId, token) {
  let response;
  try {
    response = await getActivity(activityId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
}

export function clearActivityDetails() {
  let status = 200;
  let response = {
    data: status >= 200 && status <= 206 ? true : false,
  };
  return responseDataFormat(response);
}

export const getAllActivityAttachments = async (activityId, token) => {
  let response;
  try {
    response = await getActivityAttachments(activityId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const getAllProjectAttachments = async (
  taskId,
  pageNo = 1,
  pageCount = 10,
  token
) => {
  let response;
  try {
    response = await getProjectAttachments(taskId, pageNo, pageCount, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const getEditDataProjectForm = async (projectId, communityId, token) => {
  if (projectId) {
    let response;
    try {
      response = await getEditProjectForm(projectId, communityId, token);
      // setVisible(true);
    } catch (e) {
      response = handleCatchErrors(e);
    } finally {
      return responseDataFormat(response);
    }
  }
};

export const getEditDataActivityForm = async (
  activityId,
  communityId,
  token
) => {
  let response;
  try {
    response = await getEditActivityForm(activityId, communityId, token);
    // setVisible(true);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const editProjectForm = async (data, communityId, token) => {
  let response;
  try {
    response = await updateProject(data, communityId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const deleteProject = async (projId, token) => {
  let response;
  try {
    response = await deleteProj(projId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const deleteActivity = async (actId, token) => {
  let response;
  try {
    response = await deleteAct(actId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const setMemberStatus = async (id, statusId, token) => {
  let response;
  try {
    response = await setStatus(id, statusId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
  }
};

export const setActivityStatus = async (
  activityId,
  cahngeAll,
  statusId,
  resolver,
  request,
  store,
  token
) => {
  if (statusId) {
    let response;
    try {
      response = await setActivitiesStatus(
        activityId,
        statusId,
        cahngeAll,
        token
      );
      if (cahngeAll) {
        store(null);
        resolver(request, store, activityId, token);
      }
    } catch (e) {
      response = handleCatchErrors(e);
    } finally {
    }
  }
};

export const getAllActivityMembers = async (activityId, token) => {
  let response;
  try {
    response = await getActivityMembers(activityId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const getCreateActivityProcedureForm = async (activityId, token) => {
  let response;
  try {
    response = await getActivityProcedureForm(activityId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const addActvivtyProcedure = async (data, token) => {
  let response;
  try {
    response = await addActivityProcedureForm(data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const getEditActivityProcedureForm = async (procId, token) => {
  let response;
  try {
    response = await getEditProcedure(procId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const addActivityForm = async (data, token) => {
  let response;
  try {
    response = await addActivity(data, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const deleteActivityProcedure = async (procId, token) => {
  let response;
  try {
    response = await deleteActivityProc(procId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  }
};

export const getAllActivityStatus = async (token) => {
  let response;
  try {
    response = await getActivityStatus(token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const updateActivityProcedureStatus = async (
  procId,
  statusId,
  token
) => {
  let response;
  try {
    response = await editActivityProcStatus(procId, statusId, token);
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export const searchAllProjects = async (
  communityID,
  pageNumber = 1,
  pageSize = 4,
  data = {},
  token
) => {
  let response;
  try {
    response = await searchProjects(
      communityID,
      pageNumber,
      pageSize,
      data,
      token
    );
  } catch (e) {
    response = handleCatchErrors(e);
  } finally {
    return responseDataFormat(response);
  }
};

export function projectSearchKey(searchkey) {
  let status = 200;
  let response = {
    data: status >= 200 && status <= 206 ? searchkey : null,
  };
  return responseDataFormatRedux(response, actionTypes.PROJECTSEARCHKEY);
}

export function clearProjectSearchKeys() {
  let response = {
    data: null,
  };
  return responseDataFormatRedux(response, actionTypes.PROJECTSEARCHKEY);
}
